import { ConsentFormGuardianSignersDTO, ConsentFormSignerDTO, ProspectConsentFormDTO } from "../types/ConsentForm";

export const guardianSignatureIncomplete = (signer?: ConsentFormSignerDTO) => {
  const emailIncomplete = !signer.email?.length;
  const whatsAppIncomplete = !signer.whatsappCountryId && !signer.whatsapp?.length;
  return signer.required && emailIncomplete && whatsAppIncomplete;
};

export const calcConsentFormSubHeaderText = (
  consentForm: ProspectConsentFormDTO,
  guardians: ConsentFormGuardianSignersDTO,
  isEn: boolean,
): string => {
  if (!!consentForm.completedTs) {
    return isEn ? "Signed" : "Firmado";
  }

  let numSigned = 0;
  if (!!consentForm.prospectSignedTs) numSigned++;

  if (!consentForm.guardianSignaturesRequired) {
    return isEn ? "1 Signature Required" : "1 Firma Requerida";
  } else {
    if (guardianSignatureIncomplete(guardians.guardian1) || guardianSignatureIncomplete(guardians.guardian2)) {
      return isEn ? "Multiple Signatures Required" : "Se requieren varias firmas";
    }

    const totalRequired = guardians.guardian2.required ? 3 : 2;

    if (!!guardians.guardian1.signedTs) numSigned++;
    if (!!guardians.guardian2.signedTs) numSigned++;

    if (!!numSigned) {
      return isEn ? `${numSigned} of ${totalRequired} Signed` : `${numSigned} de ${totalRequired} firmado`;
    } else {
      return isEn ? `${totalRequired} Signatures Required` : `${totalRequired} Firmas Requeridas`;
    }
  }
};
